import styled from "styled-components";

export const ScreenContainer = styled.div`
  max-width: 1200px;
`;
